import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLiffProfile } from "../../context/LiffProfileContext";
import { useTranslation } from "react-i18next";
import ErrorModal from "../modals/ErrorModal";
import OtpForm from "../otp/OtpForm";

const PdpaConsentRegister = ({ show, onAccept, onClose, payload }) => {
  const [pdpaContent, setPdpaContent] = useState("");
  const [consentStatus, setConsentStatus] = useState(null);
  const { authToken, userId } = useLiffProfile();
  const [showOtp, setShowOtp] = useState(false);
  const { t, i18n } = useTranslation();
  const [error, setError] = useState(null);
  const [isScrolledToBottom, setIsScrolledToBottom] = useState(false);

  useEffect(() => {
    const apiUrl = `${process.env.REACT_APP_API_URL}/api/pdpa/template`;
    const clientAuth = process.env.REACT_APP_CLIENT_AUTH;

    const fetchPdpa = async () => {
      try {
        const res = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "X-Client-Auth": clientAuth,
            "x-user-id": userId,
            "Accept-Language": i18n.language.toUpperCase(),
          },
        });
        const data = res?.data?.data;
        if (data?.consentMessage) {
          setPdpaContent(data.consentMessage);
        } else {
          setError(t("pdpa.not_found"));
        }
      } catch (err) {
        console.error("Error fetching PDPA:", err);
        setError(t("pdpa.fetch_error"));
      }
    };

    fetchPdpa();
  }, [authToken, userId, t]);

  const handleConsentAccept = async () => {
    // setShowOtp(true);
  };
  if (!show) return null;
  if (error) {
    return <ErrorModal error={error} onClose={onClose} />;
  }

  
  //   if (showOtp) {
  //     return (
  //       <OtpForm
  //         mobile={payload.mobile}
  //         idCard={payload.id}
  //         onSubmit={onAccept}
  //         onClose={() => setShowOtp(false)}
  //       />
  //     );
  //   }

  if (!pdpaContent) return null;

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollTop + clientHeight >= scrollHeight - 10) {
      setIsScrolledToBottom(true);
    }
  };

  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg max-w-md w-full p-6 shadow-lg relative">
          <button
            className="absolute top-2 right-3 text-gray-500 hover:text-gray-700 text-xl"
            onClick={onClose}
          >
            &times;
          </button>
          <h3 className="text-xl font-semibold mb-4">{t("pdpa_header")}</h3>
          <div
            className="overflow-y-auto max-h-[50vh] mb-4"
            onScroll={handleScroll}
          >
            <div
              className="text-base whitespace-pre-wrap text-left"
              dangerouslySetInnerHTML={{ __html: pdpaContent }}
            />
          </div>
          <div className="flex justify-center gap-4">
            <button
              className="px-6 py-2 rounded-full bg-gray-300 text-black"
              onClick={() => onAccept("N")} // ไม่ยินยอม
            >
              {t("not_consent")}
            </button>

            <button
              className={`px-6 py-2 rounded-full text-white ${
                isScrolledToBottom
                  ? "bg-primary"
                  : "bg-gray-300 cursor-not-allowed"
              }`}
              onClick={() => onAccept("C")} // ยินยอม
              disabled={!isScrolledToBottom}
            >
              {t("consent")}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default PdpaConsentRegister;
